<script>
import {getAuth} from "@/api";
import ResetPw from "@/components/ResetPw";

export default {
  name: 'EditableTable',
  props: ['data', 'columnConfigs', 'height'],
  components: {ResetPw},
  data() {
    return {
      filteredColumnConfig: [],
      currentEid: 0
    }
  },
  computed: {
    auth() {
      return getAuth()
    }
  },
  methods: {
    emitEvent(eventName, data) {
      this.$emit(eventName, data)
    },
    onSave(columnName, data) {
      const editArr = data.edit
      editArr.splice(data.edit.indexOf(columnName), 1)
      const columnAlias = this.filteredColumnConfig.filter(config => config.name === columnName)[0].alias
      this.emitEvent('save', {columnName, columnAlias, data})
    },
    onEdit(columnName, data) {
      if (!data.edit.includes(columnName)) {
        data.edit.push(columnName)
      }
      this.emitEvent('edit', {columnName, data})
    },
    onDelete(columnName, data) {
      if (!data.edit.includes(columnName)) {
        data.edit.push(columnName)
      }
      this.emitEvent('delete', {columnName, data})
    },
  },
  created() {
    this.filteredColumnConfig = this.columnConfigs.filter(item => item.needLevel <= this.auth)
  }
}
</script>

<template>
  <el-table
      border style="width: 100%"
      :data="data"
      :height="height?height:undefined"
  >
    <el-table-column v-for="column in filteredColumnConfig"
                     :prop="column.name"
                     :label="column.alias"
                     :key="column.name"
                     :align="column.align||'left'"
                     :width="column.fixWidth"
                     :min-width="column.width">
      <template slot-scope="scope" v-if="auth >= column.needLevel">
        <img v-if="column.name==='PIC'"
             :src="'//taipec.gugame.net/images/'+scope.row.PIC" alt="" style="max-height: 80px;">
        <div v-else-if="column.name==='DELETE' && auth>= column.needLevel">
          <el-button v-if="column.editable" size="mini" :type="column.type||'primary'"
                     @click="onDelete(column.name,scope.row)">刪除
          </el-button>
        </div>
        <div v-else-if="column.name==='OWNER'">
          <slot name="sales" :row="scope.row"></slot>
        </div>
        <div v-else>
          <span v-if="column.editable && scope.row.edit.includes(column.name)">
              <div v-if="column.options&& column.options.length>0">
              <el-select v-model="scope.row[column.name]" placeholder="请选择">
                <el-option
                    v-for="item in column.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div v-else>
              <el-input v-if="column.name.indexOf('DATE')>-1" type="date" v-model="scope.row[column.name]"></el-input>
              <el-input v-else type="text" v-model="scope.row[column.name]"></el-input>
            </div>
            <el-button @click="onSave(column.name, scope.row)">完成</el-button>
          </span>
          <span v-else>
            <span v-if="column.name!=='PWD'">
              <span v-if="column.options===undefined">
                {{ scope.row[column.name] }}
              </span>
              <span v-else>
                {{ column.options.filter(option => option.value == scope.row[column.name])[0].label }}
              </span>
              <!--              <span>-->
                <el-button v-if="column.editable" size="mini" @click="onEdit(column.name,scope.row)">編輯</el-button>
              <!--              </span>-->
            </span>
            <span v-else>
              <ResetPw :eid="scope.row.EID" type="primary"/>
            </span>
          </span>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>

<style scoped>

</style>
